import * as React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import * as KrispyTokens from '@krispy-tokens/blue';

const propTypes = {
  children: PropTypes.node,
};

const TH = styled.th`
  width: auto;
  white-space: nowrap;
  padding: ${KrispyTokens.KrispySpacingElementsMdSmall}px 
  ${KrispyTokens.KrispySpacingElementsHdXlarge}px;
`;

const Wrapper = styled.div`
  width: auto;
  padding-left: 24px;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: visible;
  word-break: break-word;
`;

const TableHeader = (props) => {
  const { children } = props;

  return (
    <TH>
      <Wrapper>
        {children}
      </Wrapper>
    </TH>
  );
};

TableHeader.propTypes = propTypes;

export default TableHeader;
